module.exports = __webpack_public_path__ + "static/media/Marotte_Lati_MT100-19-Panel.d0e02ff5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Lati_MT100-19-Panel.jpg
// module id = 957
// module chunks = 37